<button class="btn btn-sm btn-primary" (click)="openSetupTiktokFlashSaleModal()">
  <i class="fab fa-product-hunt"></i>
</button>

<ng-template #tiktokPushProductConfigModal let-modal>
  <form [formGroup]="configForm" (ngSubmit)="onSubmit()">
    <div class="modal-header">
      <h4 class="modal-title">Product Config</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="container mt-4">

        <!-- Config Selection -->
        <div class="form-group">
          <label>Select Configuration</label>
          <ng-select [items]="tiktokConfigs"
                     bindLabel="configName"
                     bindValue="id"
                     [(ngModel)]="selectedConfigId"
                     formControlName="configSelector"
                     (change)="onConfigSelect(selectedConfigId)">
          </ng-select>
        </div>

        <div>
          <div class="form-group">
            <label>Config Name</label>
            <input type="text" class="form-control" formControlName="configName">
          </div>

          <div class="form-group" *ngIf="merchant.merchantType != 2 && merchant.merchantType != 6 && merchant.merchantType != 7">
            <label>Template File</label>
            <input type="file" class="form-control" (change)="onFileSelected($event)" accept=".xlsx,.xls,.csv">
            <small class="form-text text-muted" *ngIf="configForm.get('templateFileLink').value">
              Current template: {{configForm.get('templateFileLink').value}}
            </small>
          </div>

          <div class="form-group" *ngIf="merchant.merchantType != 2 && merchant.merchantType != 6 && merchant.merchantType != 7">
            <label>Received Email</label>
            <input type="text" class="form-control" formControlName="receivedFileEmail">
          </div>

          <div class="form-group">
            <label>Base Price</label>
            <input type="number" class="form-control" formControlName="basePrice">
          </div>

          <div class="form-group">
            <label>Low Price Config</label>
            <input type="number" class="form-control" formControlName="lowPriceConfig">
          </div>

          <div class="form-group">
            <label>Category</label>
            <ng-select [items]="categorySearchResults"
                       [loading]="categorySearchLoading"
                       [typeahead]="categorySearchSubject"
                       (search)="onCategorySearch($event)"
                       (change)="onCategorySelect($event)"
                       placeholder="Search for a category...">
            </ng-select>
            <small class="text-muted" *ngIf="currentCategoryName && !categorySearchLoading">
              Current category: {{currentCategoryName}}
            </small>
            <div *ngIf="loadingAttributes" class="text-muted mt-2">
              <small>Loading required properties...</small>
            </div>
          </div>

          <!-- Required Properties Info (for TikTok merchants) -->
          <div *ngIf="isTikTokMerchant() && (requiredSaleProperties.length > 0 || requiredNonSaleProperties.length > 0)" class="alert alert-info mt-3">
            <h6><strong>Required Properties for This Category:</strong></h6>
            
            <!-- Required Sale Properties -->
            <div *ngIf="requiredSaleProperties.length > 0" class="mb-3">
              <strong>Sale Properties ({{requiredSaleProperties.length}}):</strong>
              <ul class="mb-0 mt-1">
                <li *ngFor="let prop of requiredSaleProperties">{{prop.name}}</li>
              </ul>
            </div>

            <!-- Required Non-Sale Properties -->
            <div *ngIf="requiredNonSaleProperties.length > 0">
              <strong>Non-Sale Properties ({{requiredNonSaleProperties.length}}):</strong>
              <ul class="mb-0 mt-1">
                <li *ngFor="let prop of requiredNonSaleProperties">
                  {{prop.name}}
                  <span *ngIf="prop.values && prop.values.length > 0" class="text-muted">
                    <small>(Available values: {{prop.values.join(', ')}})</small>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div class="form-group">
            <label>Description</label>
            <textarea class="form-control" formControlName="description"></textarea>
          </div>

          <div class="form-group">
            <label>Package</label>
            <input type="text" class="form-control" formControlName="package">
          </div>

          <div class="form-group">
            <label>Stock</label>
            <input type="number" class="form-control" formControlName="stock">
          </div>

          <!-- Sale Properties Section -->
          <div class="card bg-light p-3 mb-3">
            <h4 class="mb-2">
              Sale Properties
              <span *ngIf="getRequiredSalePropertiesMessage()" class="text-muted" style="font-size: 0.8em; font-weight: normal;">
                {{getRequiredSalePropertiesMessage()}}
              </span>
            </h4>
            <div formArrayName="saleProperties">
              <div *ngFor="let salePropCtrl of saleProperties.controls; let i = index" [formGroupName]="i" class="form-group">
                <input type="text" class="form-control mb-2" formControlName="propertyName" placeholder="Property Name">
                <input type="text" class="form-control mb-2" formControlName="value" placeholder="Value">
                <button type="button" class="btn btn-danger btn-sm mt-1" (click)="removeSaleProperty(i)">Remove</button>
              </div>
            </div>
            <button type="button" class="btn btn-primary btn-sm" (click)="addSaleProperty()">Add Sale Property</button>
          </div>


          <!-- Non-Sale Properties Section -->
          <div class="card bg-light p-3 mb-3">
            <h4 class="mb-2">
              Non-Sale Properties
              <span *ngIf="getRequiredNonSalePropertiesMessage()" class="text-muted" style="font-size: 0.8em; font-weight: normal;">
                {{getRequiredNonSalePropertiesMessage()}}
              </span>
            </h4>
            <div formArrayName="nonSaleProperties">
              <div *ngFor="let nonSalePropCtrl of nonSaleProperties.controls; let i = index" [formGroupName]="i" class="form-group">
                <input type="text" class="form-control mb-2" formControlName="propertyName" placeholder="Property Name">
                <input type="text" class="form-control mb-2" formControlName="value" placeholder="Value">
                <button type="button" class="btn btn-danger btn-sm mt-1" (click)="removeNonSaleProperty(i)">Remove</button>
              </div>
            </div>
            <button type="button" class="btn btn-primary btn-sm" (click)="addNonSaleProperty()">Add Non-Sale Property</button>
          </div>

          <!-- Sub Images Section -->
          <div class="card bg-white p-3 border mb-3">
            <h4 class="mb-2">Sub Images</h4>
            <div formArrayName="subImages">
              <div *ngFor="let subImageCtrl of subImages.controls; let i = index" class="form-group">
                <input type="text" class="form-control mb-2" [formControlName]="i" placeholder="Image URL">
                <div class="mt-2">
                  <img *ngIf="subImageCtrl.value" [src]="subImageCtrl.value" class="img-thumbnail" style="max-width: 100px;">
                </div>
                <button type="button" class="btn btn-danger btn-sm mt-1" (click)="removeSubImage(i)">Remove</button>
              </div>
            </div>
            <button type="button" class="btn btn-primary btn-sm" (click)="addSubImage()">Add Image</button>
          </div>

          <!-- Size Chart Section -->
          <div class="card bg-white p-3 border">
            <h4 class="mb-2">Size Chart</h4>
            <div class="form-group">
              <input type="text" class="form-control" formControlName="sizeChart" placeholder="Size Chart URL">
              <div class="mt-2">
                <img *ngIf="sizeChart.value" [src]="sizeChart.value" class="img-thumbnail" style="max-width: 150px;">
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>


    <div class="modal-footer">
      <div class="d-flex w-100 justify-content-between align-items-center">
        <button type="button" class="btn btn-secondary" (click)="openImportTemplateModal()">
          <i class="fas fa-file-import"></i> Import Template
        </button>
        <div>
          <button type="button" class="btn btn-light mr-2" (click)="modal.close('Close click')">Cancel</button>
          <button type="submit" class="btn btn-primary">Save</button>
        </div>
      </div>
    </div>
  </form>

</ng-template>

<!-- Import Template Modal -->
<ng-template #importTemplateModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Import Template</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container">
      <!-- Merchant Selection -->
      <div class="form-group">
        <label>Select Merchant</label>
        <ng-select 
          [items]="grantedMerchants"
          bindLabel="name"
          bindValue="merchantId"
          [(ngModel)]="selectedImportMerchantId"
          (change)="onImportMerchantSelect($event)">
        </ng-select>
      </div>

      <!-- Template Selection -->
      <div class="form-group">
        <label>Select Template</label>
        <ng-select 
          [items]="merchantTemplates"
          bindLabel="configName"
          bindValue="id"
          [(ngModel)]="selectedImportTemplateId"
          [disabled]="!selectedImportMerchantId">
        </ng-select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cancel</button>
    <button type="button" class="btn btn-primary" 
            [disabled]="!selectedImportTemplateId" 
            (click)="importTemplate()">Import</button>
  </div>
</ng-template>
